export enum ClosingTimingEnum {
  /** 今回 */ THIS = '1',
  /** 次回 */ NEXT = '2',
}

export const ClosingTiming = [
  { label: '今回', value: ClosingTimingEnum.THIS },
  { label: '次回', value: ClosingTimingEnum.NEXT },
];
